/**
 * Stile del menu laterale: scelto a livello di modulo tramite la variabile
 * d'ambiente REACT_APP_MENU_STYLE (vedi frontend/.env.example), non
 * dall'utente a runtime — build-time, come REACT_APP_API_URL.
 */
const MENU_STYLES = ['sidebar', 'hamburger', 'compact'];
const DEFAULT_STYLE = 'sidebar';

const raw = process.env.REACT_APP_MENU_STYLE;

export const MENU_STYLE = MENU_STYLES.includes(raw) ? raw : DEFAULT_STYLE;
